import api from '@/services/api';

export default {
  namespaced: true,

  state: () => ({
    projects: [],
  }),

  getters: {
    allProjects: (state) => state.projects,
    projectNames: (state) => state.projects.map((p) => p.name),
    projectByName: (state) => (name) => state.projects.find((p) => p.name === name),
  },

  mutations: {
    SET_PROJECTS(state, projects) {
      state.projects = projects;
    },
    ADD(state, project) {
      state.projects.push(project);
    },
    UPDATE(state, updated) {
      const idx = state.projects.findIndex((p) => p.id === updated.id);
      if (idx !== -1) state.projects.splice(idx, 1, updated);
    },
    DELETE(state, id) {
      state.projects = state.projects.filter((p) => p.id !== id);
    },
    RESET(state) {
      state.projects = [];
    },
  },

  actions: {
    async init({ commit }) {
      const { data } = await api.get('/projects');
      commit('SET_PROJECTS', data);
    },

    reset({ commit }) {
      commit('RESET');
    },

    async addProject({ commit }, { name, color, description }) {
      const { data } = await api.post('/projects', { name, color, description });
      commit('ADD', data);
      return data;
    },

    async updateProject({ commit }, project) {
      const { data } = await api.put(`/projects/${project.id}`, project);
      commit('UPDATE', data);
    },

    async deleteProject({ commit }, id) {
      await api.delete(`/projects/${id}`);
      commit('DELETE', id);
    },
  },
};
